export class CreateBackgroundInfoTemplate {
  jurisdictionId?: number;
  name = '';
  description = '';
}
